<script>
    import ProductTypographyText from "./ProductTypographyText";
    import ProductTypographyParameters from "./ProductTypographyParameters";

    export default {
        name: "ProductTypography",
        components: {
            ProductTypographyParameters,
            ProductTypographyText,
        },
        props: {
            product: Object,
            videoList: Array,
            selected: String,
            parametersTitle: String,
            equipmentsTitle: String,
        },
    };
</script>

<template>
    <div class="product-typography" itemprop="description">
        <div
            class="product-typography__wrapper"
            :class="{ visible: this.selected === 'description' }"
        >
            <div class="product-anchor-style js-anchor-description"></div>

            <template v-if="product.text.length > 0">
                <h2 class="product-typography-title">Описание</h2>

                <product-typography-text
                    class="product-typography__text"
                    :html-text="product.text"
                    :video-list="videoList"
                ></product-typography-text>
            </template>
        </div>

        <div
            v-if="product.allSpecifications.length > 0 || product.equipment.length > 0"
            class="product-typography__wrapper"
            :class="{ visible: this.selected === 'characteristic' }"
        >
            <h2 class="product-typography-title">Характеристики</h2>

            <product-typography-parameters
                class="product-typography__parameters"
                :parameters="product.allSpecifications"
                :equipments="product.equipment"
                :parameters-title="parametersTitle"
                :equipments-title="equipmentsTitle"
            ></product-typography-parameters>
        </div>
    </div>
</template>

<style lang="scss">
    .product-typography-title {
        margin-bottom: 16px;
        color: var(--primary-text);
        font-size: 20px;
        font-weight: var(--product-typography-title-weight);
        line-height: 24px;

        @include bp($bp-desktop-sm) {
            margin-bottom: 32px;
            font-size: 22px;
            line-height: 26px;
        }
    }

    .product-typography__wrapper {
        display: none;
        &.visible {
            display: block;
        }

        @include bp($bp-desktop-sm) {
            display: block;
        }
    }
</style>
